import { createWithEqualityFn } from 'zustand/traditional';
import { CalendarInteractionStore } from './calendarInteractionStore.types';

export const useCalendarInteractionStore =
  createWithEqualityFn<CalendarInteractionStore>((set) => ({
    disableInteraction: undefined,
    isCut: undefined,
    sourceEvent: undefined,
    isProcessing: undefined,
    eventRef: undefined,
    showEntityQuickConnect: undefined,
    showEntityQuickDisconnect: undefined,
    control: {
      setSourceEvent: (sourceEvent, isCut, disableInteraction) =>
        set((state) => {
          return {
            ...state,
            isCut,
            sourceEvent,
            disableInteraction
          };
        }),
      setEventRef: (eventRef) => set(() => ({ eventRef })),
      setIsProcessing: (isProcessing) => set(() => ({ isProcessing })),
      setShowEntityQuickConnect: (showEntityQuickConnect) =>
        set(() => ({ showEntityQuickConnect })),
      setShowEntityQuickDisconnect: (showEntityQuickDisconnect) =>
        set(() => ({ showEntityQuickDisconnect }))
    }
  }));
